import { render, staticRenderFns } from "./dot-menu.vue?vue&type=template&id=8ff58dae&"
import script from "./dot-menu.vue?vue&type=script&lang=js&"
export * from "./dot-menu.vue?vue&type=script&lang=js&"
import style0 from "./dot-menu.vue?vue&type=style&index=0&id=8ff58dae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports